// src/layouts/LandingPageCountdown/LandingPageCountdown.js

import React from "react"
import styled from "styled-components"
import scrollTo from "gatsby-plugin-smoothscroll"
import Countdown from "react-countdown"
import { Link } from "gatsby"

const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <div class="countdown-clock">
      <div class="countdown-col">
        <p class="unit">{days}</p>
        <p class="label">Days</p>
      </div>
      <div class="countdown-col">
        <p class="unit">{hours}</p>
        <p class="label">Hours</p>
      </div>
      <div class="countdown-col">
        <p class="unit">{minutes}</p>
        <p class="label">Minutes</p>
      </div>
      <div class="countdown-col">
        <p class="unit">{seconds}</p>
        <p class="label">Seconds</p>
      </div>
    </div>
  )
}

const LandingPageCountdown = ({
  countdownTopContent,
  countdownDate,
  countdownLabel,
  countdownBottomContent,
  countdownButtonText,
}) => {
  return (
    <BlockContent>
      <div
        className="top-content"
        dangerouslySetInnerHTML={{ __html: countdownTopContent }}
      />
      <div className="countdown">
        <Countdown date={countdownDate} renderer={renderer} />
        <p class="countdown-label">{countdownLabel}</p>
      </div>
      <div
        className="bottom-content"
        dangerouslySetInnerHTML={{ __html: countdownBottomContent }}
      />
      <div class="countdown-cta">
        <button>
          <Link to="/contact/">Talk to our Experts</Link>
        </button>
      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 1010px;
  width: 100%;
  margin: 50px auto;
  padding: 0 20px;
  &.narrow {
    max-width: 810px;
  }
  .countdown {
    max-width: 830px;
    margin: 40px auto;
    background-color: #2b2520;
    border: 1px solid #707070;
    border-radius: 20px;
    padding: 25px 30px;
    .countdown-clock {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;
      .countdown-col {
        width: 165px;
        text-align: center;
        p.unit {
          font-family: "Work Sans";
          font-weight: 300;
          font-size: 80px;
          line-height: 1;
          color: #fff;
          margin-bottom: 0;
        }
        p.label {
          font-family: "Work Sans";
          font-weight: 700;
          font-size: 24px;
          line-height: 1;
          letter-spacing: 2px;
          color: #fff;
          text-transform: uppercase;
          margin-bottom: 0;
        }
      }
    }
    p.countdown-label {
      text-align: center;
      font-family: "Work Sans";
      font-size: 16px;
      color: #999999;
      margin-top: 25px;
    }
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin-top: 20px;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 70px;
    color: #2b2520;
    margin-top: 0;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 48px;
    color: #2b2520;
    margin-top: 0;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  p,
  ul,
  ol {
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 400;
    line-height: 38px;
    color: #777c7c;
    margin-bottom: 0;
    a {
      color: #c44c4a;
    }
  }
  ul,
  ol {
    margin-left: 20px;
  }
  .countdown-cta {
    text-align: center;
    button {
      background-color: #c44c4a;
      color: #fff;
      font-family: "Work Sans";
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      border: none;
      padding: 12px 35px;
      margin-top: 40px;
      &:hover {
        cursor: pointer;
      }
      a {
        text-decoration: none;
        color: #fff
      }
    }
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
    h3 {
      font-size: 36px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    h4 {
      font-size: 28px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    p,
    ul {
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    .countdown {
      .countdown-clock {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 30px;
        .countdown-col {
          width: 100px;
          p.unit {
            font-size: 44px;
          }
          p.label {
            font-size: 18px;
          }
        }
      }
      p.countdown-label {
        font-size: 12px;
      }
    }
    h2 {
      font-size: 36px;
    }
    h3 {
      font-size: 28px;
    }
    h4 {
      font-size: 20px;
    }
    ul {
      margin-left: 0;
    }
    p,
    ul {
      font-size: 16px;
      line-height: 1.6;
    }
  }
`

export default LandingPageCountdown
